import FolderPathTypeEnum from '../../../../../pm/common/enums/FolderPathTypeEnum';

/**
 * * Модель запроса на создание папки без сущности
 */
export default class CreateFolderWithoutEntityRequest  {
	/**
	 * * Номер задачи
	 */
	TaskId?: number;
	/**
	 * * Номер проекта
	 */
	ProjectId?: number;
	/**
	 * * Указывает куда создаться папка
	 */
	Type?: FolderPathTypeEnum;
	constructor(obj?: Partial<CreateFolderWithoutEntityRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
